/* eslint-disable no-bitwise */
import React from 'react';
import { Avatar } from 'antd';
import { darken } from 'polished';
import { BLUE } from 'assets/styles/settings';

const style = { color: BLUE, backgroundColor: '#f5f5f5' };

function stringToColor(str) {
    let hash = 0;

    for (let i = 0; i < str.length; i += 1) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';
    for (let i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xFF;
        color += (`00${value.toString(16)}`).substr(-2);
    }

    return color;
}

/**
 * Profile avatar
 * @param {*} param This is an object contain the user information and size
 */
const ProfileAvatar = ({ user, size, className }) => (
    <Avatar
        style={{ ...style, color: darken(0.1, stringToColor(`${user?.first_name} ${user?.last_name}`)) }}
        className={`ant-avatar gx-size-${size} gx-pointer gx-mr-3 ant-avatar-circle ant-avatar-image ${className || ''}`}
        src={user?.image ? `${process.env.REACT_APP_CDN}${user.image}` : ''}
    >
        { (user?.image === '') ? user?.first_name.charAt(0).toUpperCase() : '' }
    </Avatar>
);

export default ProfileAvatar;
